module.exports = __webpack_public_path__ + "static/media/enel.98ee9159.jpg";